/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './flot.scss';

/* eslint-disable import/no-unresolved, import/default */

import flotTemplate from './flot.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

import 'javascript-detect-element-resize/detect-element-resize';
import TbFlot from "../../../flot-widget";

export default angular.module('agrolog.client.flot', [])
    .directive('agFlot', Flot)
    .name;

/*@ngInject*/
function Flot() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '=',
            subscriptionInfo: '=',
            timewindowMs: '=',
            useDashboardTimewindow: '=',
            disableAggregation: '=',
            units: '=',
            onDataLoadedCallback: '&',
            flotSettings: '=',
            flotKeySettings: '=',
            maxThreshold: '=',
            minThreshold: '=',
            legendConfig: '=',
            temperatureContent: '<',
            moistureContent: '<',
            state: '=',
            flotContainer: '<?'
        },
        controller: FlotController,
        controllerAs: 'vm',
        templateUrl: flotTemplate
    };
}

/* eslint-disable angular/angularelement */

/*@ngInject*/
function FlotController($scope, $element, $timeout, $log, agTypes, types, timeService, unitService) {

    let vm = this;

    vm.dataLoading = true;
    //vm.flotInited = false;

    vm.subscriptionOptions = {
        callbacks: {
            onDataUpdated: onDataUpdated,
            onDataUpdateError: onDataUpdateError,
            dataLoading: function(subscription) {
                vm.dataLoading = subscription.loadingData;
            }
        }
    };

    vm.tempUnit = unitService.temperatureUnitSymbol();

    vm.dataLoading = true;

    $scope.$watch('vm.dataLoading', function() {
        if (!vm.dataLoading && vm.onDataLoadedCallback) {
            vm.onDataLoadedCallback();
        }
    });

    $scope.$watch('vm.ctx', function() {
        if (vm.ctx) {
            vm.flotCtx = {
                $scope: vm.ctx.$scope,
                utils: vm.ctx.utils,
                isMobile: vm.ctx.isMobile,
                isEdit: vm.ctx.isEdit,
                settings: {
                    yaxis: {
                        tickDecimals: 1
                    },
                    xaxis: {}
                },
                units: vm.units,
                decimals: 2
            };
            if (vm.flotSettings) {
                angular.merge(vm.flotCtx.settings, vm.flotSettings);
            }
            var type = null;
            if (vm.state) {
                type = 'state';
                vm.subscriptionOptions.stateData = true;
            }
            if (vm.legendConfig) {
                vm.legendConfig.position = types.position.bottom.value;
                vm.subscriptionOptions.legendConfig = vm.legendConfig;
            }
            vm.flot = new TbFlot(vm.flotCtx, type);
        }
    });

    $scope.$on('dashboardTimewindowChanged', function (event, newDashboardTimewindow) {
        if (vm.subscription && vm.useDashboardTimewindow && vm.disableAggregation) {
            var newTimewindowConfig = angular.copy(newDashboardTimewindow);
            newTimewindowConfig.aggregation.type = types.aggregation.none.value;
            newTimewindowConfig.aggregation.limit = 500;
            vm.subscription.timeWindowConfig = newTimewindowConfig;
        }
    });

    $scope.$watch('vm.subscriptionInfo', function() {
        if (vm.subscriptionInfo) {
            if (angular.isDefined(vm.maxThreshold)) {
                vm.currentMaxThreshold = vm.maxThreshold;
                vm.yMax = vm.currentMaxThreshold * 1.3;
                if (!vm.flot.options.grid) {
                    vm.flot.options.grid = {};
                }
                vm.flot.options.grid.markings = [
                    {color: agTypes.colors.errorColor, yaxis: {from: vm.currentMaxThreshold, to: vm.currentMaxThreshold}}
                ];
                vm.flot.options.grid.markingsLineWidth = 2;
                setYAxisMax(vm.yMax);
                if (vm.legendConfig && vm.legendConfig.displayMaxThreshold) {
                    vm.legendConfig.maxThresholdColor = agTypes.colors.errorColor;
                    vm.legendConfig.maxThresholdHidden = false;
                    $scope.$watch('vm.legendConfig.maxThresholdHidden', (newVal, prevVal) => {
                        if (!angular.equals(newVal, prevVal)) {
                            if (vm.legendConfig.maxThresholdHidden) {

                                //update this place
                                vm.flot.options.grid.markings = vm.flot.options.grid.markings.filter(e => e.color !== agTypes.colors.errorColor);

                                vm.currentMaxThreshold = undefined;
                                setYAxisMax(null);
                                vm.flot.update();
                                vm.flot.redrawPlot();
                            } else {
                                vm.currentMaxThreshold = vm.maxThreshold;
                                if (vm.flot.options.grid.markings && vm.flot.options.grid.markings.length) {
                                    vm.flot.options.grid.markings.push({color: agTypes.colors.errorColor, yaxis: {from: vm.currentMaxThreshold, to: vm.currentMaxThreshold}})
                                } else {
                                    vm.flot.options.grid.markings = [
                                        {color: agTypes.colors.errorColor, yaxis: {from: vm.currentMaxThreshold, to: vm.currentMaxThreshold}}
                                    ];
                                }
                                if (vm.subscription) {
                                    onDataUpdated(vm.subscription);
                                    vm.flot.redrawPlot();
                                } else {
                                    setYAxisMax(vm.yMax);
                                    vm.flot.update();
                                    vm.flot.redrawPlot();
                                }
                            }
                        }
                    });
                }
            }

            if (angular.isDefined(vm.minThreshold)) {
                vm.currentMinThreshold = vm.minThreshold;
                vm.yMin = vm.currentMinThreshold > 10 ? vm.currentMinThreshold * 0.7 : vm.currentMinThreshold * 0.5;
                if (!vm.flot.options.grid) {
                    vm.flot.options.grid = {};
                }
                if (vm.flot.options.grid.markings && vm.flot.options.grid.markings.length) {
                    vm.flot.options.grid.markings.push({color: agTypes.colors.minErrorColor, yaxis: {from: vm.currentMinThreshold, to: vm.currentMinThreshold}})
                } else {
                    vm.flot.options.grid.markings = [
                        {color: agTypes.colors.minErrorColor, yaxis: {from: vm.currentMinThreshold, to: vm.currentMinThreshold}}
                    ];
                }
                vm.flot.options.grid.markingsLineWidth = 2;
                setYAxisMin(vm.yMin);
                if (vm.legendConfig && vm.legendConfig.displayMinThreshold) {
                    vm.legendConfig.minThresholdColor = agTypes.colors.minErrorColor;
                    vm.legendConfig.minThresholdHidden = false;
                    $scope.$watch('vm.legendConfig.minThresholdHidden', (newVal, prevVal) => {
                        if (!angular.equals(newVal, prevVal)) {
                            if (vm.legendConfig.minThresholdHidden) {

                                //update this place
                                vm.flot.options.grid.markings = vm.flot.options.grid.markings.filter(e => e.color !== agTypes.colors.minErrorColor);

                                vm.currentMinThreshold = undefined;
                                setYAxisMin(null);
                                vm.flot.update();
                                vm.flot.redrawPlot();
                            } else {
                                vm.currentMinThreshold = vm.minThreshold;
                                if (vm.flot.options.grid.markings && vm.flot.options.grid.markings.length) {
                                    vm.flot.options.grid.markings.push({color: agTypes.colors.minErrorColor, yaxis: {from: vm.currentMinThreshold, to: vm.currentMinThreshold}})
                                } else {
                                    vm.flot.options.grid.markings = [
                                        {color: agTypes.colors.minErrorColor, yaxis: {from: vm.currentMinThreshold, to: vm.currentMinThreshold}}
                                    ];
                                }
                                if (vm.subscription) {
                                    onDataUpdated(vm.subscription);
                                    vm.flot.redrawPlot();
                                } else {
                                    setYAxisMin(vm.yMin);
                                    vm.flot.update();
                                    vm.flot.redrawPlot();
                                }
                            }
                        }
                    });
                }
            }

            reset();
            vm.dataLoading = true;
            if (vm.useDashboardTimewindow) {
                if (vm.disableAggregation) {
                    vm.subscriptionOptions.useDashboardTimewindow = false;
                    vm.subscriptionOptions.timeWindowConfig = angular.copy(vm.ctx.dashboardTimewindow);
                    vm.subscriptionOptions.timeWindowConfig.aggregation.type = types.aggregation.none.value;
                    vm.subscriptionOptions.timeWindowConfig.aggregation.limit = 500;
                } else {
                    vm.subscriptionOptions.useDashboardTimewindow = true;
                }
            } else {
                vm.subscriptionOptions.timeWindowConfig = timeService.defaultTimewindow();
                vm.subscriptionOptions.timeWindowConfig.realtime.timewindowMs = vm.timewindowMs;
                if (vm.disableAggregation) {
                    vm.subscriptionOptions.timeWindowConfig.aggregation.type = types.aggregation.none.value;
                    vm.subscriptionOptions.timeWindowConfig.aggregation.limit = 500;
                }
            }
            vm.flotElement = angular.element('#flot', $element);
            if (vm.flotContainer) {
                vm.containerElement = angular.element(vm.flotContainer);
            }
            addResizeListener($element[0], onResize); // eslint-disable-line no-undef
            vm.ctx.subscriptionApi.createSubscriptionFromInfo (
                types.widgetType.timeseries.value, vm.subscriptionInfo, vm.subscriptionOptions, false, false).then(
                function(subscription) {
                    vm.subscription = subscription;
                    if (vm.flotKeySettings) {
                        vm.subscription.data.forEach((dataKeyData, i) => {
                            var dataKey = dataKeyData.dataKey;
                            var keySettings = dataKey.settings;
                            dataKey.units = getRelevantUnits(dataKey.name);
                            if (i === 0) {
                                keySettings.axisPosition = "left";
                            } else {
                                keySettings.axisPosition = (dataKey.units === vm.subscription.data[0].dataKey.units) ? "left" : "right";
                            }

                            if (!keySettings) {
                                dataKey.settings = keySettings = {};
                            }
                            angular.merge(keySettings, vm.flotKeySettings);
                        });
                    }
                    if (vm.legendConfig) {
                        vm.legendData = vm.subscription.legendData;
                    }
                    vm.flot.init(vm.flotElement, vm.subscription);
                    vm.subscription.subscribe();
                    if (vm.flotContainer) {
                        onResize(true);
                    }
                }
            );
        }
    });

    $scope.$on('$destroy', function() {
        reset();
    });

    $scope.$on('resize', function() {
        onResize();
    });

    $scope.$on('editModeChanged', function() {
        if (vm.flotCtx) {
            vm.flotCtx.isEdit = vm.ctx.isEdit;
        }
        if (vm.flot) {
            vm.flot.checkMouseEvents();
        }
    });

    $scope.$on('mobileModeChanged', function() {
        if (vm.flotCtx) {
            vm.flotCtx.isMobile = vm.ctx.isMobile;
        }
        if (vm.flot) {
            vm.flot.checkMouseEvents();
        }
    });

    function onResize(init) {
        if (vm.flot && vm.containerElement) {
            var width = vm.containerElement.width();
            var height = vm.containerElement.height();
            resizeAccordingToParent(width, height);
            if (!init) {
                $timeout(() => {
                    var newWidth = vm.containerElement.width();
                    var newHeight = vm.containerElement.height();
                    if (newWidth != width || newHeight != height) {
                        resizeAccordingToParent(width, height);
                    }
                });
            }
        } else if (vm.flot) {
           vm.flot.resize();
        }
    }

    function resizeAccordingToParent(newWidth, newHeight) {
        if (vm.flot.ctx.plot && vm.flot.ctx.plotInited) {
            if (newWidth && newHeight) {
                vm.flot.$element.width(newWidth);
                vm.flot.$element.height(newHeight);
                vm.flot.ctx.plot.resize();
                if (vm.flot.chartType !== 'pie') {
                    vm.flot.ctx.plot.setupGrid();
                }
                vm.flot.ctx.plot.draw();
            }
        }
    }

    function reset() {
        if (vm.flotElement) {
            removeResizeListener($element[0], onResize); // eslint-disable-line no-undef
        }
        if (vm.subscription) {
            vm.ctx.subscriptionApi.removeSubscription(vm.subscription.id);
        }
        if (vm.flot) {
            vm.flot.destroy();
        }
    }

    function onDataUpdateError(subscription, e) {
        $log.error(e);
    }

    function setYAxisMax(max) {
        var changed = false;
        if (vm.flot.yaxes) {
            for (var y = 0; y < vm.flot.yaxes.length; y++) {
                if (vm.flot.yaxes[y].max != max) {
                    vm.flot.yaxes[y].max = max;
                    changed = true;
                }
            }
        }
        if (vm.flot.options.yaxes) {
            for (y = 0; y < vm.flot.options.yaxes.length; y++) {
                if (vm.flot.options.yaxes[y].max != max) {
                    vm.flot.options.yaxes[y].max = max;
                    changed = true;
                }
            }
        }
        return changed;
    }

    function setYAxisMin(min) {
        var changed = false;
        if (vm.flot.yaxes) {
            for (var y = 0; y < vm.flot.yaxes.length; y++) {
                if (vm.flot.yaxes[y].min != min) {
                    vm.flot.yaxes[y].min = min;
                    changed = true;
                }
            }
        }
        if (vm.flot.options.yaxes) {
            for (y = 0; y < vm.flot.options.yaxes.length; y++) {
                if (vm.flot.options.yaxes[y].min != min) {
                    vm.flot.options.yaxes[y].min = min;
                    changed = true;
                }
            }
        }
        return changed;
    }

    function onDataUpdated(subscription) {
        var maxChanged = false;
        var minChanged = false;
        if (angular.isDefined(vm.currentMaxThreshold)) {
            var newMax = vm.yMax;
            for (let i = 0; i < subscription.data.length; i++) {
                let series = subscription.data[i];
                if (!series.dataKey.hidden) {
                    var max = calculateMax(series.data);
                    if (max != null) {
                        newMax = Math.max(max, newMax);
                    }
                }
            }
            if (newMax > vm.yMax) {
                maxChanged = setYAxisMax(null);
            } else {
                maxChanged = setYAxisMax(vm.yMax);
            }
        }

        if (angular.isDefined(vm.currentMinThreshold)) {
            var newMin = vm.yMin;
            for (let i = 0; i < subscription.data.length; i++) {
                let series = subscription.data[i];
                if (!series.dataKey.hidden) {
                    var min = calculateMin(series.data);
                    if (min != null) {
                        newMin = Math.min(min, newMin);
                    }
                }
                if (newMin < vm.yMin) {
                    minChanged = setYAxisMin(null);
                } else {
                    minChanged = setYAxisMin(vm.yMin);
                }
            }
        }

        if (vm.flot) {
            vm.flot.update();
            if (maxChanged || minChanged) {
                vm.flot.redrawPlot();
            }
        }
    }

    function calculateMax(data) {
        if (data.length > 0) {
            var result = Number(data[0][1]);
            for (var i=1;i<data.length;i++) {
                result = Math.max(result, Number(data[i][1]));
            }
            return result;
        } else {
            return null;
        }
    }

    function calculateMin(data) {
        if (data.length > 0) {
            var result = Number(data[0][1]);
            for (var i=1;i<data.length;i++) {
                result = Math.min(result, Number(data[i][1]));
            }
            return result;
        } else {
            return null;
        }
    }

    function isTemperaturePrefix (key) {
        if (key.startsWith(agTypes.telemetry.sensorLines.temperaturePrefix)) {
            return true
        } else if (key.startsWith(agTypes.telemetry.sensorLines.deltaTemperaturePrefix)) {
            return true
        }
        return false
    }

    function isMoisturePrefix (key) {
        if (key.startsWith(agTypes.telemetry.sensorLines.deltaMoisturePrefix)) {
            return true
        } else if (key.startsWith(agTypes.telemetry.sensorLines.moisturePrefix)) {
            return true
        } else if (key.startsWith(agTypes.telemetry.sensorLines.emcPrefix)) {
            return true
        }
        return false
    }

    function getRelevantUnits(keyName) {
        let res;
        if (keyName.startsWith(agTypes.telemetry.headSpaceSensor.humidity)) {
            res = agTypes.units.humidity;
        } else if (keyName.startsWith(agTypes.telemetry.headSpaceSensor.pressure)) {
            res = agTypes.units.pressure;
        } else if (keyName.startsWith(agTypes.telemetry.headSpaceSensor.co2level)) {
            res = agTypes.units.co2Level;
        } else if (keyName.startsWith(agTypes.telemetry.levelIndicator.cropLevelPrefix)) {
            res = agTypes.units.cropLevel;
        } else if (isTemperaturePrefix(keyName)) {
            res = vm.tempUnit;
        } else if (isMoisturePrefix(keyName)) {
            res = agTypes.units.moisture;
        } else {
            res = vm.units;
        }
        return res;
    }
}